<template>
  <div>
    <!--<div class="slide" v-on:mouseover="stop()" v-on:mouseout="move()">
      <div class="slideshow">
        <transition-group tag="ul" name="image">
          <li v-for="(img, index) in imgArray" v-show="index===mark" :key="index">
            <a href="#">
              <div class="lunTu" :style='"background: url("+imgArray[index].image_url+") no-repeat center center;"'></div>
            </a>
          </li>
        </transition-group>
      </div>

    </div>-->
    <div class="swiper-container gallery-top swiper-container-horizontal">
      <div class="swiper-wrapper">
        <div v-for="(item,i) in imgArray" class="swiper-slide" :style="{background: 'url(' + imgArray[i].image_url + ')no-repeat center'}" :key="i"></div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination" style="position:absolute"></div>
    </div>
    
    <div style="text-align:center;background-color:#fcfcfc">
      <img style="width:793px" src="../../site/mapBanner.png">
    </div>
    
    <div>
      <div class="titleIntro">
        <p class="titleTxt">糖糖圈誓言</p>
        <p class="titleEnglish">Tang Tang Quan Oath</p>
      </div>
      <div style="margin-top:30px;font-size:14px;color:#999;text-align:center;line-height:25px">
        <p>糖糖圈致力于糖尿病教育事业，奉行人道主义精神，坚守“以病人为中心”的信念，履行“保存生命，减轻痛苦，</p>
        <p>促进健康”的职责。健康所系，性命相托!我们决心竭尽全力减少病人因糖尿病带来的痛苦，</p>
        <p>让1型糖尿病患者生活得既有质量又有尊严!</p>
      </div>

      <div class="serviceContent">
        <div class="serviceLeft left">
          <img src="../../site/intro1.png">
        </div>
        <div class="serviceRight right">
          <div class="serviceTitle">标准化照护服务</div>
          <div class="serviceTxt">
            糖糖圈糖尿病多学科医疗团队共同照护服务，服务周期长达终身， 通过密集干预和定期随访的形式，提供便捷、不间断、个体化、 专业的高端糖尿病管理服务，确保患者长期有效的自我管理， 致力于以最大限度保障患者的生活质量，维持最佳健康状态， 让患者拥有更愉快便捷的正常生活，摆脱疾病及并发症困扰。  
          </div>
        </div>
        <div style="clear:both"></div>
      </div>

      <div class="serviceContent">
        <div class="serviceLeft left">
          <div class="serviceTitle">甜蜜讲堂直播</div>
          <div class="serviceTxt">
            定期邀请国内知名内分泌专家教授、医生，营养师，控糖达人，糖友家长， 糖尿病教育师，心理医生等进行线上，以视频直播的形式，传授知识和经 验，并在线答疑解惑，我们已经进行了150多期，非常适合您进入学习。
          </div>
        </div>
        <div class="serviceRight right">
          <img src="../../site/intro2.png">
        </div>
        <div style="clear:both"></div>
      </div>

      <div class="serviceContent">
        <div class="serviceLeft left">
          <img src="../../site/intro3.png">
        </div>
        <div class="serviceRight right">
          <div class="serviceTitle">线上公益咨询</div>
          <div class="serviceTxt">
            便捷的线上咨询医生已成功帮助上万糖友完成线上问诊服务 医生+患教师+营养师+心理师教您进阶血糖教育 把“神秘”控糖技能告诉您。  
          </div>
        </div>
        <div style="clear:both"></div>
      </div>

      <div class="serviceContent">
        <div class="serviceLeft left">
          <div class="serviceTitle">线下糖尿病诊所</div>
          <div class="serviceTxt">
            爱宝惟诊所是全国首家1型糖尿病专科诊所由内分泌专科医师、糖尿病教育师、 营养师、心理咨询师等组成，依据并遵从“循证”的医学诊疗方法，为患者提供 国际标准的医疗服务。诊所充分考虑1型患者深层次需求，秉持“让1型糖尿病生 活更美好”的服务理念。诊所设置患者教育、营养、 检验、心理等多个科目。
          </div>
        </div>
        <div class="serviceRight right">
          <img src="../../site/intro4.png">
        </div>
        <div style="clear:both"></div>
      </div>
    </div>
    
    <div>
      <div class="titleIntro">
        <p class="titleTxt">其他功能</p>
        <p class="titleEnglish">The Other Features</p>
      </div>
      <div style="margin:auto; width:1200px;">
        <div class="functionList left">
            <img src="../../site/function1.png">
            <div class="functionTitle">专业课程</div>
            <div class="functionTxt">由资深调糖专家制作<br>涉及调糖、调针、调泵，营养和心理等<br>高效助力自我管理</div>
        </div>
        <div class="functionList left" style="margin-left:20px">
            <img src="../../site/function2.png">
            <div class="functionTitle">同伴互动</div>
            <div class="functionTxt">这里是1型糖友专属家园<br>尽情分享、提问、总结经验<br>糖友互帮互助，营造家的温暖</div>
        </div>
        <div class="functionList left" style="margin-left:20px">
            <img src="../../site/function3.png">
            <div class="functionTitle">食物库</div>
            <div class="functionTxt">多达30多万种食物<br>快速查询想要查的食物营养素<br>重量标尺快速快捷计算营养素含量</div>
        </div>
        <div class="functionList left" style="margin-left:20px">
            <img src="../../site/function4.png">
            <div class="functionTitle">血糖日历</div>
            <div class="functionTxt">独有算法评估控糖情况<br>不同颜色标识，一目了然<br>帮助糖友控糖的好帮手</div>
        </div>
        <div class="functionList left">
            <img src="../../site/function5.png">
            <div class="functionTitle">实惠商城</div>
            <div class="functionTxt">生活不容易、耗材不能报销、经济负担重？<br>糖糖圈商城帮糖友集采<br>只会降价，加入会员还能更省钱</div>
        </div>
        <div class="functionList left" style="margin-left:20px">
            <img src="../../site/function6.png">
            <div class="functionTitle">医保汇总</div>
            <div class="functionTxt">汇集全国1型医保政策<br>助糖友快速了解本地医疗政策<br>长期推动1型医保制度完善</div>
        </div>
        <div class="functionList left" style="margin-left:20px">
            <img src="../../site/function7.png">
            <div class="functionTitle">共享糖化漂流</div>
            <div class="functionTxt">还在跑医院排队测糖化？<br>快来参加糖化漂流活动<br>在家快速测糖化，省时省心更省钱</div>
        </div>
        <div class="functionList left" style="margin-left:20px">
            <img src="../../site/function8.png">
            <div class="functionTitle">动态血糖云</div>
            <div class="functionTxt">搭建动态血糖分享网址<br>实现家人远程查看血糖<br>患者血糖情况全家掌握</div>
        </div>
        <div style="clear:both"></div>
      </div>

    </div>

    <div>
      <div class="titleIntro">
        <p class="titleTxt">糖糖圈会员服务</p>
        <p class="titleEnglish">Tang Tang Quan Membership Service</p>
        <p class="titleEnglish" style="margin-top:35px">开通终身制会员，尊享15大会员权益，糖糖圈为您终身服务</p>
      </div>
      <div class="memberContent">
        <div class="memberList left">
          <img src="../../site/icon1.png">
          <div class="memberTxt">1对1血糖管理</div>
        </div>
        <div class="memberList left">
          <img src="../../site/icon2.png">
          <div class="memberTxt">会员商城折扣</div>
        </div>
        <div class="memberList left">
          <img src="../../site/icon3.png">
          <div class="memberTxt">泵定制优惠</div>
        </div>
        <div class="memberList left">
          <img src="../../site/icon4.png">
          <div class="memberTxt">共享糖化漂流</div>
        </div>
        <div class="memberList left">
          <img src="../../site/icon5.png">
          <div class="memberTxt">动态血糖云</div>
        </div>
        <div class="memberList left">
          <img src="../../site/icon6.png">
          <div class="memberTxt">定制讲堂主题</div>
        </div>
        <div class="memberList left">
          <img src="../../site/icon7.png">
          <div class="memberTxt">线下医疗照护</div>
        </div>
        <div style="clear:both"></div>
        <div class="clickMore" @click="clickMore">了解更多</div>
      </div>
    </div>

    <div style="margin-top:100px; padding:100px 0px; background-color:#fcfcfc;">
      <div class="titleIntro">
        <p class="titleTxt" style="margin-top:0;">合作伙伴</p>
        <p class="titleEnglish">Cooperative Partner</p>
      </div>
      <div class="partnerContent">
        <div style="margin-top:50px">
          <img style="margin-left:45px" src="../../site/ttq1.png">
          <img src="../../site/ttq2.png">
          <img src="../../site/ttq3.png">
          <img src="../../site/ttq4.png">
          <img src="../../site/ttq5.png">
          <img src="../../site/ttq6.png">
        </div>
        <div style="margin-top:30px">
          <img style="margin-left:45px" src="../../site/ttq7.png">
          <img src="../../site/ttq8.png">
          <img src="../../site/ttq9.png">
          <img src="../../site/ttq10.png">
          <img src="../../site/ttq11.png">
          <img src="../../site/ttq12.png">
        </div>
        <div style="margin-top:30px">
          <img style="margin-left:45px" src="../../site/ttq13.png">
          <img src="../../site/ttq14.png">
          <img src="../../site/ttq15.png">
          <img src="../../site/ttq16.png">
          <img src="../../site/ttq17.png">
          <img src="../../site/ttq18.png">
        </div>
        <div style="margin-top:30px">
          <img style="margin-left:45px" src="../../site/ttq19.png">
          <img src="../../site/ttq20.png">
          <img src="../../site/ttq21.png">
          <img src="../../site/ttq22.png">
          <img src="../../site/ttq23.png">
          <img src="../../site/ttq24.png">
        </div>
      </div>
    </div>

    <footerBottomer></footerBottomer>

  </div>
  

</template>

<script>
  import Swiper from '../../site/swiper.min.js'   //引入Swiper插件
  import footerBottomer from './footerBottomer.vue'
  
  let num1=""
  let num2=""
  let num3=""
  export default {
    name: 'top',
    components: {
     footerBottomer
  	},
    data () {
      return {
      	host: this.GLOBAL.host,
        news: [{titles:1, authors: 2, tips: 3, descriptions: 4, pubDates: 5, links: 6, cc: 113}],
        word: 'hello,word',
        timer: null, //定时器
        mark: 0, //比对图片索引的变量
        imgArray: [{
          image_url:'http://vod.ttq.so/image/default/9E26B64A7D1A4DDAB94684271437D2A4-6-2.png'
        },{
          image_url:'http://vod.ttq.so/image/default/9E26B64A7D1A4DDAB94684271437D2A4-6-2.png'
        }],
        box1:{
            img:[this.GLOBAL.host+'/site/1-14.png',this.GLOBAL.host+'/site/1-11.png',this.GLOBAL.host+'/site/1-12.png'],
            title:['糖尿病诊所','线上患教服务','同伴互助控糖'],
            content:[
              '国内首个<br />1型糖尿病专科诊所<br />依据并遵从“循证”的医学诊疗方法<br/>为患者提供国际标准的医疗服务',
              '便捷的线上随访医院<br />已成功帮助上千糖友完成线上患教工作<br />医生+患教师教你进阶血糖教育<br />把“神秘”控糖技能告诉你',
              '分享并互评每天的血糖<br />学习控糖乐此不疲，温暧有爱<br />这是1型糖友最温暖的“朋友圈”'
              
            ],
          color:['#0acab1','#f19ec2','#f7ca51']
        },
        box2:{
          img:[this.GLOBAL.host+'/site/2-11.png',this.GLOBAL.host+'/site/2-12.png',this.GLOBAL.host+'/site/2-13.png',this.GLOBAL.host+'/site/2-14.png',this.GLOBAL.host+'/site/2-15.png',this.GLOBAL.host+'/site/2-16.png'],

          title:['血糖日历','同城糖友聚会','音频漫画视频专题','游戏学知识','自我管理','卫教随访'],
          content:[
            '回顾过去每月控糖成绩单<br />在进步中成长<br />帮助90%的糖友有效降低糖化血红蛋白<br />糖友的潜能大大滴',
            '无论您在中国哪个角落<br />总会有一场离您家最近的糖友聚会<br />让同城的糖友从APP走到线下<br />从此同城控糖再也不孤单',
            '琳琅满目的学习方式<br />充满情感的糖友故事/科普内容<br />多姿多彩的漫画、视频<br />满足不同糖友的需求',
            '控糖知识也能过关闯将？<br />还能与同伴试比高？<br /> 更能获取奖励？<br />没错，控糖不再枯燥。',
            '细分年龄段血糖控制目标和不<br/>同治疗方案，内置血糖<br/>场景智能提示，教你<br/>听身体的声音，做自己的医生',
            '院外随访，数据跟踪，精确<br/>问卷，复诊报告，医<br/>疗卫教人员提高<br/>患者依从性的好帮手！'
          ]
        },
        numList:{
          title:['糖糖圈实时累计血糖数','糖糖圈控糖互助贴子','糖糖圈甜蜜讲堂累计收听量'],
          num:{0:[],1:[],2:[]},
          time:''
        },
        companyNews:{},
      }
    },

    mounted() {
      setTimeout(function(){
        let swiper = new Swiper('.swiper-container', {
          pagination: {
            el: '.swiper-pagination',
          },
          loop : true,
          autoplay:true,
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
            pagination : '.swiper-pagination',
            paginationClickable :true
          },
        });
      },100);
      
  
  	},


    methods: {
      clickMore(){
        var that=this;
        window.scrollTo(0,0);
        that.$emit("getMsgFormSon","");
        this.$router.push('/userInfo');
      },

      getImg (){
        this.$http.get(this.host+'/site/index.html').then((response) => {
          this.imgArray=response.data.data.Carousel_Figure;
          setTimeout(function(){
            let swiper = new Swiper('.swiper-container', {
              pagination: {
                el: '.swiper-pagination',
              },
              loop : true,
              autoplay:true,
              autoplay: {
                delay: 5000,
                stopOnLastSlide: false,
                disableOnInteraction: false,
                pagination : '.swiper-pagination',
								paginationClickable :true
              },
            });
          },100);
          num1=""+response.data.data.Statistic_Data.bg_count+"";
          this.numList.num[0]=num1.replace(/(.)(?=[^$])/g,"$1,").split(",");
          num2=""+response.data.data.Statistic_Data.share_count+"";
          this.numList.num[1]=num2.replace(/(.)(?=[^$])/g,"$1,").split(",");
          num3=""+response.data.data.Statistic_Data.fm_visit_times+"";
          this.numList.num[2]=num3.replace(/(.)(?=[^$])/g,"$1,").split(",");
          this.numList.time=response.data.data.Statistic_Data.count_date;
          this.companyNews=response.data.data.Company_News;
        }, (response) => {});
      }
    },
    created: function () {
      this.getImg();
    }
  }
</script>
<style scoped>
  @import url("../assets/swiper.min.css");
  .gallery-top{
    width: 100%;
    min-width: 1040px;
    margin-top: 90px;
    position: relative;
    height: 650px;
  }
  .gallery-thumbs .swiper-slide{
    width:30%;
    height:6rem;
    opacity:0.3;
  }
  #top{margin-top: 90px}
  .bar {
    width: 100%;
    margin: 20px auto 0 auto;
    z-index: 10;
    text-align: center;
  }
  .active {
    background: #00b9cd !important;
    width: 12px !important;
    height: 12px !important;
  }
  .image-enter-active {
    transform: translateX(0);
    transition: all 1.5s ease;
  }
  .image-leave-active {
    transform: translateX(-100%);
    transition: all 1.5s ease;
  }
  .image-enter {
    transform: translateX(100%);
  }
  .image-leave {
    transform: translateX(0);
  }
  .box-1{max-width: 1200px;margin: 0 auto;text-align: center;padding-top:60px;padding-bottom: 60px;min-width: 1040px}
  .box-1s{max-width: 1200px;margin: 0 auto;text-align: center;padding-top:60px;padding-bottom: 60px;min-width: 1040px}
  .huiSe{background: #f7f8fa;width: 100%;min-width: 1040px}
  .huiSe1{background: url("../../site/ttqappbg.jpg") no-repeat center}
  .box1-ul{max-width: 1200px;min-width: 1040px;margin-top: 20px;text-align: left}
  .box1-ul li{width: 33.3%;display: inline-block;line-height: 24px;text-align: center;vertical-align: top;margin-top: 40px}
  .ul-div{width: 330px;  margin: 0 auto;  overflow: hidden;  border: 1px solid #e9ebeb;box-shadow: 0 0 5px #e9ebeb;  border-radius: 5px;height: 380px}
  .ul-p{height: 200px;line-height: 265px;width: 330px;margin: 0 auto}
  .title1{font-size:20px;margin: 20px 0;font-width:fold;color: #333}
  .content1{font-size:14px;color: #999}
  .numTitle{font-size: 30px;color: #333;margin-top: 50px}
  .numNum{color: #333;font-size: 24px;margin: 40px 0}
  .numNum .numListTu0{margin-left: 10px;font-size:70px;display: inline-block;background: url("../../site/3-bg.png");width: 130px;height: 126px;color: #04b7a0;line-height: 126px}
  .numNum .numListTu1{margin-left: 10px;font-size:70px;display: inline-block;background: url("../../site/31-bg.png");width: 130px;height: 126px;color: #f36fa7;line-height: 126px}
  .numNum .numListTu2{margin-left: 10px;font-size:70px;display: inline-block;background: url("../../site/32-bg.png");width: 130px;height: 126px;color: #f7ca51;line-height: 126px}
  .numTime{font-size: 16px;color: #999}
  .diTu{background: url("../../site/4-1.png") no-repeat center;width: 100%;height: 836px}
  .diTu span{text-align: right;display: inline-block;position: relative;  top: 790px;  left: 300px;}
  .diTu label{font-size: 26px;font-weight: bold}
  .box6-1{width: 49%;color: #333;display: inline-block;vertical-align: top}
  .box6-11{font-size: 36px;color: #fff}
  .box6-12 label{font-size: 16px;text-align: left;display: inline-block;margin-left: 26px;margin-top: 40px;color: #fff;line-height: 24px;}
  .box6-13{height: 199px;background: url("../../site/ewm.png") no-repeat center;margin: 40px 0;background-size: auto 100%}
  .box6-14{height: 63px;width: 208px;display: inline-block;background: url("../../site/xzbut.png");color: #fff;font-size: 26px;padding-top: 10px}
  .box6-2{background: url("../../site/5-2.png") no-repeat center;width: 50%;height: 545px;display: inline-block;vertical-align: top}
  .introduction{color: #333;font-size: 36px;margin-bottom: 40px;letter-spacing: 13px}
  .introduction label{color: #999;font-size: 20px;position: relative;top:-20px;left:-5px;letter-spacing: 0}
  .box61-tu{width: 35%;height: 110px;display: inline-block;filter: grayscale(100%);cursor:pointer}
  .box62-tu{width: 28%;height: 110px;display: inline-block;filter: grayscale(100%);cursor:pointer}
  .box61-tu:hover{filter: grayscale(0);}
  .box62-tu:hover{filter: grayscale(0);}
  .introduction-list{margin: 60px auto 0 auto;  cursor: pointer;  border: 1px solid #e8eaeb;box-shadow: 0 0 10px #b5bdbe;width: 97%; max-width:1170px;  border-radius: 20px;  padding: 20px 20px 1px 0;  position: relative;}
  .list-tu{width:220px;height: 200px;display: inline-block;margin-right: 20px;border-radius: 10px;position: absolute;left: -30px;  bottom:20px;}
  .list-centBox{min-width: 550px;width: 610px; height: 180px;display: inline-block;text-align: left;vertical-align: top;margin-left: 140px}
  .list-title{color: #333;font-size: 20px;margin-bottom: 10px}
  .list-cent{color: #999;font-size: 14px;line-height: 30px; word-break:break-all;display:-webkit-box; -webkit-line-clamp:4; -webkit-box-orient:vertical; overflow:hidden;}
  .boxImg{transition: all .5s linear;cursor: pointer}
  .boxImg:hover{transform: scale(1.2);}

  .left{float: left;}
  .right{float: right;}
  .titleTxt{margin-top:150px;letter-spacing: 10px;text-align: center;font-size: 32px;color: #4F4F4F;}
  .titleEnglish{margin-top:10px;font-size: 16px;color: #999999;text-align: center;}
  .serviceContent{margin:auto; margin-top: 100px; width: 1200px;}
  .serviceLeft,.serviceRight{width:500px}
  .serviceTitle{margin-top: 40px; width: 50px;font-size:26px; line-height: 90px; color: #4F4F4F;white-space:nowrap;border-bottom: 3px solid #00b9cd;}
  .serviceTxt{margin-top: 30px; line-height: 30px; font-size:14px;color: #999;}


  .functionList{width: 280px;}
  .functionTitle{margin-top:-80px; font-size:20px;color: #4F4F4F;text-align: center;}
  .functionTxt{margin-top:10px; font-size:14px;color: #999;text-align: center;line-height: 25px;}
  .memberContent{margin:auto; margin-top:70px; width: 1200px;}
  .memberList{margin-left:74px}
  .memberTxt{margin-top:15px; text-align:center; color: #4F4F4F;font-size: 14px;}
  .clickMore{cursor: pointer; margin:auto; margin-top: 50px; width:200px;height:46px;text-align: center; line-height: 46px;font-size:16px;color: #02BFD3;background-color: #EDFDFF;border-radius: 28px;}
  .partnerContent{margin:auto; width:1200px;}
  .company{font-size: 14px;color:#4f4f4f;line-height: 35px;}
  .companyErcode{font-size:14px;color:#4f4f4f;text-align: center;}
  .companyErcode img{width: 100px;}
</style>
<style>
  .swiper-pagination-bullet{background-color: #666666;opacity: .3;}
  .swiper-pagination-bullet-active{background-color: #00b9cd;opacity:1;}
</style>



// WEBPACK FOOTER //
// index.vue?3db3e29e